import { Select as AntdSelect } from 'antd';
import styled from 'styled-components';
import { BorderedField } from './Flex';


const StyledSelect = styled(AntdSelect).attrs({
    bordered: false
})`
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    color: var(--sp-text-color);
`;

export const Select = (props) => (
    props.bordered
        ? <BorderedField>
            <StyledSelect {...props} />
        </BorderedField>
        : <StyledSelect {...props} />
);

Select.Option = styled(AntdSelect.Option)`
    color: var(--sp-paragraph-color);
`;